import { Numeric8BoxOutlineIcon } from './Numeric8BoxOutlineIcon';

/**
 * author: Google
 * id DC2B6D38-A6B3-4171-AAC6-E08EF2C23710
 * name numeric-8-box-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-8-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumericEightBoxOutlineIcon = Numeric8BoxOutlineIcon;
export default NumericEightBoxOutlineIcon